import React from "react";
import { BaseViewWidget } from "../components/BaseViewWidget";
import { EmptyViewFieldPlaceholder } from "../components/EmptyViewFieldPlaceholder";
import { toDateString } from "../utils/dateUtils";

export default function DateWidget(props) {
  var label = props.label,
      value = props.value,
      metadata = props.schema.metadata;

  return React.createElement(
    BaseViewWidget,
    { label: label, help: metadata.help },
    value ? toDateString(value) : React.createElement(EmptyViewFieldPlaceholder, null)
  );
}